import {getStore} from "trim-redux";
import {FA} from "./fa";

export function translate(string, lang = "") {
    if(lang === "")
        lang = getStore('locale');
    if (lang === "fa"){
        return FA[string];
    }

}

